import { render, staticRenderFns } from "./GroupMemberInvite.vue?vue&type=template&id=2786526e&scoped=true"
import script from "./GroupMemberInvite.vue?vue&type=script&lang=js"
export * from "./GroupMemberInvite.vue?vue&type=script&lang=js"
import style0 from "./GroupMemberInvite.vue?vue&type=style&index=0&id=2786526e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2786526e",
  null
  
)

export default component.exports